import { POST  } from './../api';

export const getBills = () => {
  const session = JSON.parse(localStorage.getItem('persist:root')).session;
  
  return POST('/bills', {
    "domaine": JSON.parse(session).apiUrl
  });
}
